


<script>

import BarList from '../components/bar-list'
import TabdesForm from './tabdes-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            tabdes: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        tabdesList: function () {
            return this.$store.getters.getTabdesList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        getStatus(status) {
            if (status == '1')
              return 'Válida'
            else
            if (status == '3')
              return 'Vencida'
            else
            if (status == '2')
              return 'Não iniciada'
        },
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codtabdes = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codtabdes = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtabdes":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {            
            this.$store.dispatch('loadTabdes', { filter: this.filter, page: this.nextPage } )
            console.log(
                this.tabdesList
            )
            this.offset = ''
        }    


    },

    components: {
        BarList, TabdesForm
    },

    created () {
        this.showForm = false
        this.loadData()
    },

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Tabela de Desconto" 
                plural-entity="Tabelas de Desconto"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição da tabela">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="tabdesList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="tabdes in tabdesList" :key="tabdes.codtabdes">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-percent" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ tabdes.descricao }}</h2>
                                    <span class="nb-card-badge" :class="tabdes.status == 'A' ? 'nb-card-badge--success' : 'nb-card-badge--inactive'">
                                        {{ getStatus(tabdes.status) }}
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="tabdes.codtabdes">
                                    Código <strong>{{ tabdes.codtabdes }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{ barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar' }" 
                                :moreActions="[]" 
                                @edit="handleEdit(tabdes.codtabdes)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail">
                            <span class="nb-card-detail-label">Vigência (Início à Término)</span>
                            <strong>{{ tabdes.dtinicio | formatData }} à {{ tabdes.dttermino | formatData }}</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <tabdes-form v-if="showForm" :index="this.codtabdes" :crud="this.crud" @closeform="closeForm"></tabdes-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--success {
  color: #166534;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.nb-card-badge--inactive {
  color: #92400e;
  background: #fffbeb;
  border-color: #fde68a;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/tabdes-list.vue